import React from "react"
import moment from "moment"

export default ({ publishedAt, ...props }) => (
  <time {...props} dateTime={publishedAt}>
    {moment(publishedAt).format("MMMM Do, YYYY - h:mm a")}
  </time>
)
